// RPC wrappers for the analytics forget-me flow. The actual event-emission
// logic lives in `services/AnalyticsService.ts`; this module is the
// supabase-client-bound surface for the destructive-action and consent
// machinery.

import { client } from './client';
import { throwIfSupabaseError } from './throwIfSupabaseError';

export async function forgetMe(anonymousId?: string | null): Promise<number> {
    // The optional anonymous_id lets an authed wipe also sweep
    // never-stitched rows belonging to this browser (e.g. ones emitted by
    // the unload-time beacon before the JWT fix). The server still requires
    // `auth.uid()`; the anon id is just a hint about which orphan rows to
    // also remove.
    const response = await client.rpc('analytics_forget_me', {
        p_anonymous_id: anonymousId ?? undefined,
    });
    throwIfSupabaseError(response);
    const data = response.data;
    return typeof data === 'number' ? data : Number(data ?? 0);
}

export async function forgetAnonymous(anonymousId: string): Promise<number> {
    const response = await client.rpc('analytics_forget_anonymous', {
        p_anonymous_id: anonymousId,
    });
    throwIfSupabaseError(response);
    const data = response.data;
    return typeof data === 'number' ? data : Number(data ?? 0);
}

export async function stitchIdentity(anonymousId: string): Promise<number> {
    const response = await client.rpc('analytics_stitch_identity', {
        p_anonymous_id: anonymousId,
    });
    throwIfSupabaseError(response);
    const data = response.data;
    return typeof data === 'number' ? data : Number(data ?? 0);
}
